import {useDispatch} from 'react-redux';
import {setOptionActive} from './../store/filters';
import {setActiveFilterCategory} from './../store/app';

// props
//  category
//  optionName
const FilterPill = (props) => {
    let dispatch = useDispatch();
    let optionName;
    switch(props.category.type) {
        case "checkbox":
            optionName = props.optionName;
            break;
        case "range":
            optionName = props.category.displayName;
    }
    function handlePillClick(e) {
        e.preventDefault();
        dispatch(setActiveFilterCategory(null));
        dispatch(setOptionActive(props.category.dataPoint, props.optionName, false))
    }
    return (
        <button className={"pill"} onClick={handlePillClick}><div className={"crossSymbol"} />{optionName}</button>
    )
}

export default FilterPill;